import React, { FC } from "react";
import { Button } from "../../button/button";
import { InfoIcon } from "@/components/assets/icons";
import { ButtonColor } from "@/enums";
import { useTranslations } from "next-intl";

type TProps = {
  title: string;
  closeModal: () => void;
  confirmDelete: () => void;
};

const DeleteAlert: FC<TProps> = ({ title, closeModal, confirmDelete }) => {
  const t = useTranslations();

  return (
    <div className="flex !w-[29.3125rem] flex-col items-center justify-between px-[28px] pb-[50px]">
      <div className="h-[8.75rem] w-[8.75rem] rounded-full bg-[#fef7e6] p-[30px]">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#f5af02] p-[22px]">
          <InfoIcon className="fill-white" />
        </div>
      </div>
      <h2 className="text-center text-[2.5rem] font-bold">{t(title)}</h2>
      <div className="mt-8 flex w-full gap-[15px]">
        <Button
          className="!font-medium"
          color={ButtonColor.SECONDARY}
          onClick={closeModal}
        >
          {t("cancel")}
        </Button>
        <Button
          className="!bg-[#f9f9f9] !font-medium !text-[#d80027]"
          onClick={confirmDelete}
        >
          {t("delete")}
        </Button>
      </div>
    </div>
  );
};

export { DeleteAlert };
